module.exports = __webpack_public_path__ + "img/humidity.38a96807.svg";